export default __webpack_public_path__ + "static/careers-george-signature-0d0328daa1ff205a88d485bbeed64ff6.svg";